.root {
  width: 100%;
}
